import providerCatalog from '../providerCatalog';
import type { PlatformCostProviderId } from '../types';

const listPlatformCostProviderIds = (): PlatformCostProviderId[] =>
    Object.keys(providerCatalog) as PlatformCostProviderId[];

export default listPlatformCostProviderIds;
